import './Dashboard.css'
import AddProduct from './AddProduct';
function Dashboard() {
    return (
      <div className="dashboard">
        <AddProduct/>
      </div>
    );
}

export default Dashboard;
  